"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var Shimmer_1 = __importDefault(require("./Shimmer"));
exports.default = Shimmer_1.default;
